import Vue from 'vue'
import Vuex from 'vuex'
import CartStore from './cart'
import ListStore from './list'
import SocketStore from './socket'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        searching: false,
    },
    mutations: {
        searchStarted(state) {
            state.searching = true;
        },
        searchFinished(state) {
            state.searching = false;
        }
    },
    actions: {
        socketSearchFinished(context) {
            context.commit('list/groupList');
            context.commit('searchFinished');
        },
        socketPartsFound: function(context, msg) {
            if(msg.data.spares) {
                context.commit('list/addSparesToList', msg.data.spares);
            }
        },
        runSearch: function(context, request) {
            context.commit('searchStarted');
            Vue.prototype.$socket.send(JSON.stringify(request));
        },
        clearFound: function(context) {
            context.commit('list/clearList');
        }
    },
    modules: {
        cart: CartStore,
        list: ListStore,
        socket: SocketStore,
    },
})
